@if (label) {
  <label class="mb-1 block text-xs" [for]="uid">
    @if (showRequiredAsterisk) {
      <span class="font-bold text-aux-error">*</span>
    }
    {{ label }}
  </label>
}
<ng-container>
  <label class="relative block text-gray-400 focus-within:text-gray-600">
    @if (icon) {
      <span
        class="pointer-events-none absolute right-3 top-1/2 h-4 -translate-y-1/2 translate-x-1/3 transform"
      >
        <aux-icon [name]="icon" />
      </span>
    }
    <input
      #inputElement
      class="block h-10 w-full appearance-none rounded-sm border-aux-gray-dark text-sm font-medium placeholder-gray-400 shadow-sm focus-within:placeholder-gray-600 focus:border-aux-blue focus:ring-2 focus:ring-aux-blue-light-200"
      decimalMarker="."
      auxFormError
      [customErrorMessages]="customErrorMessages"
      [ngClass]="{ 'tabular-nums': type === 'number', 'pr-7': !!icon }"
      [class]="inputClassName"
      [id]="uid"
      [type]="type"
      [label]="label"
      [prefix]="maskProperties.prefix || ''"
      [suffix]="maskProperties.suffix || ''"
      [mask]="maskProperties.mask"
      [thousandSeparator]="maskProperties.thousandSeparator || ''"
      [dropSpecialCharacters]="!!maskProperties.dropSpecialCharacters"
      [allowNegativeNumbers]="!!maskProperties.allowNegativeNumbers"
      [separatorLimit]="maskProperties.separatorLimit || ''"
      [placeholder]="placeholder || label"
      [labelForErrorMessage]="label || placeholder"
      [formControl]="fc"
      [attr.disabled]="disabled || null"
      [autocomplete]="autocomplete"
      [min]="min"
      [max]="max"
      (ngModelChange)="onChangeValue(fc.value)"
      (blur)="onBlur()"
      (keydown)="onKeyDown($event)"
    />
    <div
      class="content-container"
      [style.transform]="fc.invalid ? 'translateY(-110%)' : 'translateY(-50%)'"
    >
      <ng-content></ng-content>
    </div>
  </label>
</ng-container>
